import styled from 'styled-components';

export const ClickableText = styled.span`
  cursor: pointer;
`;
